import React from "react";

const SearchFilterButtonsSkeleton = () => {
  return (
    <>
      <section className="bg-grey-100 px-[12px] py-[16px] fixed bottom-0 w-full lg:sticky lg:top-0 z-[4]">
        <div className="max-w-container mx-auto flex gap-[8px] small">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              className="flex gap-[8px] md:hidden"
              key={`mobile-${index + 1}`}
            >
              <span className="skeleton skeleton-text-animated min-w-[120px] min-h-[37px] flex !m-0"></span>
            </div>
          ))}
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              className="flex gap-[8px] hidden md:block"
              key={`desktop-${index + 1}`}
            >
              <span className="skeleton skeleton-text-animated min-w-[120px] min-h-[37px] flex !m-0"></span>
            </div>
          ))}
          <button
            type="button"
            className="flex items-center justify-center gap-[4px] cursor-pointer px-0 text-grey-50 hover:underline xl:px-[16px] lg:shrink-0"
          >
           <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.8173 1.8173C2.24037 1.39423 2.9263 1.39423 3.34937 1.8173L8 6.46794L12.6506 1.8173C13.0737 1.39423 13.7596 1.39423 14.1827 1.8173C14.6058 2.24037 14.6058 2.9263 14.1827 3.34937L9.53206 8L14.1827 12.6506C14.6058 13.0737 14.6058 13.7596 14.1827 14.1827C13.7596 14.6058 13.0737 14.6058 12.6506 14.1827L8 9.53206L3.34937 14.1827C2.9263 14.6058 2.24037 14.6058 1.8173 14.1827C1.39423 13.7596 1.39423 13.0737 1.8173 12.6506L6.46794 8L1.8173 3.34937C1.39423 2.9263 1.39423 2.24037 1.8173 1.8173Z"
                fill="#CBD5E1"
              />
            </svg>
            <span className="skeleton skeleton-text-animated descrip min-w-[40px]"></span>
          </button>
        </div>
      </section>
    </>
  );
};

export default SearchFilterButtonsSkeleton;
